import React, { useState, useCallback } from 'react'
import ErrorBoundary from '../errorboundry'
import { Form, Grid, Message } from 'semantic-ui-react'
import AddtionalDocumentAGS from './AGS/addtionalDocumentAGS'
import AdditionalInfo from './AGS/additionalInfo'
import ItemParties from './itemParties'
import MerchForm1 from './merchForm1'
import MerchForm2 from './merchForm2'
import MerchForm3 from './merchForm3'
import MerchForm4 from './merchForm4'
import MerchForm5 from './merchForm5'
import MerchForm6 from './merchForm6'
import MerchForm7 from './merchForm7'
import Authorization from './authorizationForm'
import SupplyChainActor from './supplyChainActorForm'
import DutiesTaxes from './dutiesTaxes'
import SupportingDocuments from './supportingDocs'
import AdditionalDocs from './AdditionalDocument'
import TaxInformation from './taxInformation'
import PreviousDocuments from './previousDocuments'
import Dependencies from './dependencies'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from '../../../hooks'
import { deleteMechandiseItem, updateInvoiceHeaderFieldValue, updateLineData } from '../../actions/index'
import ToggleButton from '../../../commonComponents/formComponents/toggleButton'
import Container from './container'
import MerchandiseCostType from '../../../commonComponents/commonValueBuildUpTab/merchandiseCostType'
import { TranslateContext } from '../TranslateContext'
import { ItemDependencies } from './itemDependencies'
import { useContext } from 'react'
import { InvoiceToggleContext } from '@commonComponents/accordion/AccordianInvoice'

const MerchandiseDetails = ({
  lineItemIndex,
  invoiceId,
  invoiceIndex,
  isFormEnabled,
  merchandiseId,
  updateInvoiceDataById,
  fieldPattern,
  validateError,
  initItemsTabValidation,
  procedureList,
  isDMS,isImportShipment, isDisabled, declarationStatus
}) => {
  
  const {state}=useContext(InvoiceToggleContext)
  const active=state[merchandiseId]

  const dispatch = useDispatch()
  const translate = React.useContext(TranslateContext).translate
  const procedure = useSelector(state=>state.Shipment.exitInfo?.procedure)
  

  const { saveForm, deleteForm } = useForm("")

  const declarationType = isImportShipment ? 'IM' : 'EX'

  const saveData = useCallback((params) => saveForm({ "invoices": [{ "invoiceId": invoiceId, "lineItems": [{ "merchandiseId": merchandiseId, "invoiceId": invoiceId, ...params }] }] }), [invoiceId, merchandiseId, saveForm])
  const updateData = useCallback((params) => dispatch(updateLineData(invoiceId, merchandiseId, params)), [invoiceId, merchandiseId])

  const deleteData = useCallback(async () => {
    const response = await deleteForm({ invoices: [{ invoiceId, lineItems: [{ merchandiseId }] }] })
    if (response) {
      dispatch(deleteMechandiseItem(invoiceId, merchandiseId))
      dispatch(initItemsTabValidation())
    }
  }, [invoiceId, merchandiseId, dispatch, deleteForm])

  const updateResponse = useCallback(async (key, params) => {
    const response = await saveData(params)

    if (response?.responseMessage)
      updateData({ [`${key}`]: response?.responseMessage })

  }, [saveData, updateData])

  const updateCalculatedValue = useCallback(async (params, key) => {
    const response = await saveData(params)
    const { invoiceHeader, invoices } = response
    const { lineItems, invoiceId, shipmentId, ...rest } = invoices?.[0]
    if(key==='invoiceVal'){
      const eurVal = lineItems?.[1]?.eurVal || lineItems?.[0]?.eurVal
      updateData({eurVal:eurVal})
    }
    dispatch(updateInvoiceHeaderFieldValue(invoiceHeader))
    updateInvoiceDataById(rest)
  }, [saveData, updateInvoiceDataById])

  return (
    <ErrorBoundary>
      <div
        key={`merchandiseDetail-${merchandiseId}`}
        id={`${merchandiseId}`}
        className={'accordian-section tab-contentInvoiceM ab '}
      >
        <Message>
        <ToggleButton
          id={`toggleMerchandise-${invoiceId}-${merchandiseId}`}
          title={(isActive) => (
            isActive 
            ? 'merchandise' : ""
            // <MerchandiseHeader
            //   isDMS={isDMS}
            //   isImportShipment={isImportShipment}
            //   invoiceId={invoiceId}
            //   lineItemIndex={lineItemIndex}
            // />
          )}
          // onClick={() => setLineFlag(!lineflag)}
          toggleId={merchandiseId}
          confirmationMsg='Merchandise Line Item'
          lineNumber={lineItemIndex + 1}
          // isActive={lineflag}
          onDelete={deleteData}
        />
        {active && (
          <>
            <Form.Group className='float-container mb-2' widths='equal'>
              <Grid>
                <MerchForm1
                  lineItemIndex={lineItemIndex}
                  invoiceId={invoiceId}
                  merchandiseId={merchandiseId}
                  invoiceIndex={invoiceIndex}
                  saveData={saveData}
                  updateData={updateData}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                />


                <MerchForm2
                  lineItemIndex={lineItemIndex}
                  invoiceId={invoiceId}
                  merchandiseId={merchandiseId}
                  invoiceIndex={invoiceIndex}
                  saveData={saveData}
                  updateData={updateData}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                />

                <MerchForm3
                  lineItemIndex={lineItemIndex}
                  invoiceId={invoiceId}
                  invoiceIndex={invoiceIndex}
                  saveData={saveData}
                  updateData={updateData}
                  isDMS={isDMS}
                  onChange={updateResponse}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                  procedureList={procedureList}
                />

                <MerchForm4
                  lineItemIndex={lineItemIndex}
                  invoiceId={invoiceId}
                  merchandiseId={merchandiseId}
                  saveData={saveData}
                  updateData={updateData}
                  isDMS={isDMS}
                  isImportShipment={isImportShipment}
                  invoiceIndex={invoiceIndex}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                />

                <MerchForm5
                  lineItemIndex={lineItemIndex}
                  invoiceId={invoiceId}
                  merchandiseId={merchandiseId}
                  saveData={saveData}
                  updateData={updateData}
                  updateCalculatedValue={updateCalculatedValue}
                  invoiceIndex={invoiceIndex}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                />

                <MerchForm6
                  invoiceIndex={invoiceIndex}
                  lineItemIndex={lineItemIndex}
                  invoiceId={invoiceId}
                  merchandiseId={merchandiseId}
                  saveData={saveData}
                  updateData={updateData}
                  isDMS={isDMS}
                  onChange={updateResponse}
                  updateCalculatedValue={updateCalculatedValue}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                />

                <MerchForm7
                  invoiceIndex={invoiceIndex}
                  lineItemIndex={lineItemIndex}
                  invoiceId={invoiceId}
                  merchandiseId={merchandiseId}
                  saveData={saveData}
                  updateData={updateData}
                  isDMS={isDMS}
                  onChange={updateResponse}
                  updateCalculatedValue={updateCalculatedValue}
                  fieldPattern={fieldPattern}
                  validateError={validateError}
                />
              </Grid>
            </Form.Group>
            <Container
              merchandiseId={merchandiseId}
              invoiceId={invoiceId}
              lineItemIndex={lineItemIndex}
            />

            {isDMS ? (
              <SupportingDocuments
                merchandiseId={merchandiseId}
                lineItemIndex={lineItemIndex}
                invoiceId={invoiceId}
              />
            ) : (
              <AddtionalDocumentAGS
                merchandiseId={merchandiseId}
                invoiceIndex={invoiceIndex}
                lineItemIndex={lineItemIndex}
                invoiceId={invoiceId}
                isDisabled={isDisabled}
                fieldPattern={fieldPattern}
                validateError={validateError}
                initItemsTabValidation={initItemsTabValidation}
                declarationStatus={declarationStatus}
              />
            )}

            {isDMS ? (
              <AdditionalDocs
                merchandiseId={merchandiseId}
                lineItemIndex={lineItemIndex}
                invoiceId={invoiceId}
              />
            ) : (
              <AdditionalInfo
                merchandiseId={merchandiseId}
                invoiceIndex={invoiceIndex}
                lineItemIndex={lineItemIndex}
                invoiceId={invoiceId}
              />
            )}
            <PreviousDocuments
              merchandiseId={merchandiseId}
              invoiceIndex={invoiceIndex}
              lineItemIndex={lineItemIndex}
              invoiceId={invoiceId}
              isDMS={isDMS}
              isImportShipment={isImportShipment}
              fieldPattern={fieldPattern}
              validateError={validateError}
              initItemsTabValidation={initItemsTabValidation}
            />
             {((isDMS && isImportShipment) || (!isDMS && !isImportShipment)) && (
              <MerchandiseCostType
                merchandiseId={merchandiseId}
                invoiceId={invoiceId}
                isFormEnabled={isFormEnabled}
                translate={translate} //have to make context available in ES_APP to remove it from here
              />
            )}

            {isDMS && isImportShipment && ['H1', 'H4', 'H5', 'I1'].includes(procedure) && (
              <ItemDependencies
                translate={translate} 
                invoiceId={invoiceId}
                isFormDisabled={true}
                merchandiseId={merchandiseId}
              />
            )}

            {isDMS && <ItemParties />}

            {isDMS && (
              <Authorization
                merchandiseId={merchandiseId}
                lineItemIndex={lineItemIndex}
                invoiceId={invoiceId}
                isFormEnabled={isFormEnabled}
                declarationType={declarationType}
              />
            )}
            {isImportShipment && (
              <>
                <TaxInformation
                  merchandiseId={merchandiseId}
                  invoiceId={invoiceId}
                  lineItemIndex={lineItemIndex}
                  isFormEnabled={isFormEnabled}
                  invoiceIndex={invoiceIndex}
                />

                <Dependencies merchandiseId={merchandiseId} invoiceId={invoiceId} />
                <DutiesTaxes merchandiseId={merchandiseId} invoiceId={invoiceId} />
              </>
            )}

            {isDMS && !isImportShipment && (
              <SupplyChainActor
                merchandiseId={merchandiseId}
                declarationType={declarationType}
                invoiceId={invoiceId}
                lineItemIndex={lineItemIndex}
                isFormEnabled={isFormEnabled}
                invoiceIndex={invoiceIndex}
              />
            )}
          </>)}
          </Message>
      </div>
    </ErrorBoundary>
  )
}

export default React.memo(MerchandiseDetails)
